var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form-item',{attrs:{"label":_vm.$t('url')}},[_c('el-input',{attrs:{"placeholder":_vm.$t('enter_value')},model:{value:(_vm.url),callback:function ($$v) {_vm.url=$$v},expression:"url"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }